module.exports = __webpack_public_path__ + "img/mat_403.29ced14d.png";